import { client } from "../dtos/Client";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/from";
import * as Dtos from "../dtos/Tmd.dtos";

export const trialItemCategoryApi = {
    getTrialItemCategoriesByTrialId: (trialId?: number): Observable<Dtos.GetTrialItemCategoriesByTrialIdResponse> => {
        //Create the request.
        let request: Dtos.GetTrialItemCategoriesByTrialId = new Dtos.GetTrialItemCategoriesByTrialId();

        request.trialId = trialId;

        //Send request.
        const response: Promise<Dtos.GetTrialItemCategoriesByTrialIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    }
}